import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-banner',
  templateUrl: './s-polaris-banner.component.html',
  styleUrls: ['./s-polaris-banner.component.scss'],
  standalone: false,
})
export class PolarisBannerComponent {
  @Input() tone: 'info' | 'success' | 'warning' | 'critical' = 'info';
  @Input() icon = 'more_information';
}
